// Core Team section on the Home page: shows key team members using reusable cards.

import { useTranslation } from "react-i18next";
import Section from "./Section";
import { coreTeam } from "../../mock/homeData";
import PersonCard from "./PersonCard";

function CoreTeamSection() {
  const { t } = useTranslation();

  return (
      <Section
        id="team"
        eyebrow={t("home.team.eyebrow")}
        title={t("home.team.title")}
      >
        <div className="personGrid">
          {coreTeam.map((p, idx) => (
            <PersonCard
              key={p.name}
              name={p.name}
              role={t(p.roleKey)}
              imageSrc={p.image}
              imageAlt={p.name}
              linkedIn={p.linkedIn}
              className="personCard--animated"
              style={{ animationDelay: `${idx * 70}ms` }}
            />
          ))}
        </div>
      </Section>
  );
}

export default CoreTeamSection;
